import React from 'react';
import moment from 'moment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import BlockIcon from '@material-ui/icons/Block';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { capitalizeFirstLetter } from '../../../../utils';
import { SESSION_STATUS, sessionStatusConfig } from '../constants';


// Data room section for the folder URL, by root folder or else by category
const ROOT_FOLDER_SECTIONS = {
  technical_records: 'technical',
  inspection_records: 'inspection',
  contract_records: 'contract',
  maintenance_records: 'maintanence',
  discrepancy_records: 'discrepancy',
};
const FOLDER_SECTIONS = { 1: 'technical', 2: 'discrepancy', 3: 'contract', 4: 'inspection', 5: 'maintanence' };
const folderSection = (session) => ROOT_FOLDER_SECTIONS[session.root_folder_name] || FOLDER_SECTIONS[session.category] || 'technical';
export const folderLink = (session) => (session.asset_type && session.asset_slug && session.folder_uuid ?
  `/${session.asset_type}/${session.asset_slug}/data-room/${folderSection(session)}/${session.folder_uuid}` : null);

const statusIcons = {
  [SESSION_STATUS.INTERRUPTED]: <WarningIcon />,
  [SESSION_STATUS.PAUSED]: <PauseCircleFilledIcon />,
  [SESSION_STATUS.ACTIVE]: <CloudUploadIcon />,
  [SESSION_STATUS.PREPARING]: <CloudUploadIcon />,
  [SESSION_STATUS.COMPLETED]: <CheckCircleIcon />,
  [SESSION_STATUS.FAILED]: <ErrorIcon />,
  [SESSION_STATUS.CANCELLED]: <BlockIcon />,
};

export const getConfig = (status) => sessionStatusConfig[status] || { label: capitalizeFirstLetter((status || 'Unknown').toLowerCase()), color: '#64748b', background: '#edf1f7', bar: '#94a3b8' };

export const formatTime = (value) => moment(value).format('MMM DD, YYYY hh:mm A');

// Longer estimates come from a near-zero speed and mean nothing, so they're capped
const MAX_DURATION_SECONDS = 99 * 60 * 60;

export const formatDuration = (seconds) => {
  if (!seconds || !isFinite(seconds)) return null;
  if (seconds > MAX_DURATION_SECONDS) return '99h+';
  if (seconds < 60) return `${Math.max(1, Math.round(seconds))}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

export const StatusChip = ({ status }) => {
  const config = getConfig(status);
  return (
    <span className="upload-progress__status-chip" style={{ color: config.color, background: config.background }}>
      {statusIcons[status] || null} {config.label}
    </span>
  );
};
